import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import { newRangeYearFilter } from "./typefactories";

export function initSliderFilter(node, {min, max, start}) {
    const slider = noUiSlider.create(node, {
        range: {
            'min': min,
            'max': max
        },
        step: 1,
        start: start,
        tooltips: true,
        format: wNumb({
            decimals: 0
        })
    });

    slider.on('change', function () {
        const mm = this.get();
        node.dispatchEvent(new CustomEvent("change", {detail: newRangeYearFilter(mm[0], mm[1])}));
    });

    // patch tooltip
    mergeTooltips(node, 25, ' - ', slider);

    return {
        update({start}) {
            slider.set(start);
        },
        destroy() {
            slider.off('change');
            slider.destroy();
        }
    }
}

/**
 * @credits https://refreshless.com/nouislider/examples/#section-merging-tooltips
 *
 * @param {HTMLElement} slider with an initialized slider
 * @param {number} threshold Minimum proximity (in percentages) to merge tooltips
 * @param {string} separator String joining tooltips
 * @param {NoUiSlider} sliderInstance NoUiSlider instance
 */
function mergeTooltips(slider, threshold, separator, sliderInstance) {

    const textIsRtl = getComputedStyle(slider).direction === 'rtl';
    const isRtl = sliderInstance.options.direction === 'rtl';
    const isVertical = sliderInstance.options.orientation === 'vertical';
    const tooltips = sliderInstance.getTooltips();
    const origins = sliderInstance.getOrigins();

    // Move tooltips into the origin element. The default stylesheet handles this.
    tooltips.forEach(function (tooltip, index) {
        if (tooltip) {
            origins[index].appendChild(tooltip);
        }
    });

    sliderInstance.on('update', function (values, handle, unencoded, tap, positions) {

        const pools = [[]];
        const poolPositions = [[]];
        const poolValues = [[]];
        let atPool = 0;

        // Assign the first tooltip to the first pool, if the tooltip is configured
        if (tooltips[0]) {
            pools[0][0] = 0;
            poolPositions[0][0] = positions[0];
            poolValues[0][0] = values[0];
        }

        for (let i = 1; i < positions.length; i++) {
            if (!tooltips[i] || (positions[i] - positions[i - 1]) > threshold) {
                atPool++;
                pools[atPool] = [];
                poolValues[atPool] = [];
                poolPositions[atPool] = [];
            }

            if (tooltips[i]) {
                pools[atPool].push(i);
                poolValues[atPool].push(values[i]);
                poolPositions[atPool].push(positions[i]);
            }
        }

        pools.forEach(function (pool, poolIndex) {
            const handlesInPool = pool.length;

            for (let j = 0; j < handlesInPool; j++) {
                let handleNumber = pool[j];

                if (j === handlesInPool - 1) {
                    let offset = 0;

                    poolPositions[poolIndex].forEach(function (value) {
                        offset += 1000 - value;
                    });

                    let direction = isVertical ? 'bottom' : 'right';
                    let last = isRtl ? 0 : handlesInPool - 1;
                    let lastOffset = 1000 - poolPositions[poolIndex][last];
                    offset = (textIsRtl && !isVertical ? 100 : 0) + (offset / handlesInPool) - lastOffset;

                    // Center this tooltip over the affected handles
                    tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator);
                    tooltips[handleNumber].style.display = 'block';
                    tooltips[handleNumber].style[direction] = offset + '%';
                } else {
                    // Hide this tooltip
                    tooltips[handleNumber].style.display = 'none';
                }
            }
        });
    })
}

